import Alert from "../typescript/modules/alert";
import Countdown, { CountdownType } from "../typescript/modules/countdown";
import Header from "../typescript/modules/header";
import LoadContent from "../typescript/modules/load-content";
import Nav from "../typescript/modules/nav";
import Popups from "../typescript/modules/popups";
import PrintIt from "../typescript/modules/print";
import SearchAutocompleteDesktop from "../typescript/modules/search-autocomplete-desktop";
import SearchAutocompleteMobile from "../typescript/modules/search-autocomplete-mobile";
import SelectorFilter from "../typescript/modules/selector-filter";
import SiteStore from "../typescript/modules/site-store";
import Tooltip from "../typescript/modules/tooltip";
import Usps from "../typescript/modules/usps";
import TrackLists from "../typescript/modules/track-lists";
import Wishlist from "../typescript/modules/wishlist";
import ProductShare from "../typescript/modules/product-share";
import site from "../typescript/site";
import ProductCard from "../typescript/modules/product-card";
import ScrollCarousel from "../typescript/modules/scroll-carousel";
import "../typescript/modules/algolia-tracking";
import SimpleBar from 'simplebar';
import LiveChat from "../typescript/modules/live-chat";


site.preInit();
(<any>window).Usps = Usps;
if (document.querySelector('.js-usp-slider')) {
	new Usps();
}
new Nav();
new Header();

function initCountdownBanners() {
	const countdownBanners = SelectorFilter.excludeByClass(document.querySelectorAll('[data-countdown]'), 'has-initialised');
	for (let i = 0; i < countdownBanners.length; i++) {
		new Countdown(countdownBanners[i] as HTMLElement, '', CountdownType.Offer);
	}
}
function initProductCountdown() {
	const productCountdowns = SelectorFilter.excludeByClass(document.querySelectorAll('.countdown'), 'js-countdown-done');
	for (let i = 0; i < productCountdowns.length; i++) {
		new Countdown(productCountdowns[i] as HTMLElement, productCountdowns[i].getAttribute('data-cutoff-hide-prefix') === 'true' ? '' : 'in', CountdownType.Product);
	}
}
(<any>window).Countdown = Countdown;
(<any>window).initProductCountdown = initProductCountdown;
initProductCountdown();
initCountdownBanners();

new SiteStore();
(<any>window).SiteStore = SiteStore;


new Alert();

(<any>window).LoadContent = LoadContent;
const loadContentElements = SelectorFilter.excludeByClass(document.querySelectorAll('[data-load-content]'), 'js-load-content-done');
for (let i = 0; i < loadContentElements.length; i++) {
	new LoadContent(loadContentElements[i] as HTMLElement);
}

(<any>window).Tooltip = Tooltip;

new Tooltip();

new PrintIt();

(<any>window).popups = new Popups();

new SearchAutocompleteDesktop();
(<any>window).SearchAutocomplete = SearchAutocompleteDesktop;

new SearchAutocompleteMobile();
(<any>window).MobileSearchAutocomplete = SearchAutocompleteMobile;

const listsToTrack = document.querySelectorAll('[data-list-id]');
for (let i = 0; i < listsToTrack.length; i++) {
	new TrackLists(listsToTrack[i]);
}

new ProductCard();

new Wishlist();
new ProductShare();

const scrollCarousels = document.querySelectorAll(".js-scroll-carousel:not(.js-scroll-carousel-done):not(.js-ignore-on-load)");
for (let i = 0; i < scrollCarousels.length; i++) {
	new ScrollCarousel(scrollCarousels[i]);
}

const customScrollbars = document.querySelectorAll('.js-custom-scrollbar') as NodeListOf<HTMLElement>;
for (let i = 0; i < customScrollbars.length; i++) {
	new SimpleBar(customScrollbars[i], {
		autoHide: false
	});
}

new LiveChat();
